<template>
  <main class="dotation-page text-[#0D2651]">
    <!-- ========== SECTION 1 : plage — voyage + où trouver le code ========== -->
    <section class="dotation-s1 relative z-[5]">
      <img
        src="@/assets/images/dotations/fond-section1.jpg"
        alt=""
        class="absolute inset-0 w-full h-full min-h-[100vh] object-cover object-[center_60%] pointer-events-none"
        aria-hidden="true"
      />
      <div
        class="relative z-10 max-w-[1440px] mx-auto px-4 sm:px-6 pb-32 sm:pb-40 lg:pb-48"
      >
        <!-- Hero (le header réserve déjà la hauteur sous la barre fixe) -->
        <div class="text-center pt-10 sm:pt-6 lg:pt-10 pb-10 sm:pb-14">
          <img
            src="@/assets/images/dotations/tentez de gagner.svg"
            alt="Tentez de gagner"
            class="mx-auto mb-4 sm:mb-6 w-[min(85vw,280px)] sm:w-[min(75vw,380px)] lg:w-[480px] h-auto drop-shadow-md"
          />
          <div
            class="inline-flex items-center justify-center rounded-2xl bg-[#FEEFC7] px-5 pt-0.5 pb-2 mb-3 sm:mb-4 max-w-[95vw]"
          >
            <h1
              class="font-barlow-condensed font-bold text-[#0D2651] uppercase text-[44px] sm:text-[52px] lg:text-[64px] leading-tight text-center"
            >
              1 voyage d'une valeur de 10&nbsp;000€
            </h1>
          </div>
          <p
            class="font-barlow-condensed font-bold text-[#0D2651] uppercase text-[28px] sm:text-[36px] lg:text-[48px] lg:leading-tight mb-3 sm:mb-4 max-w-4xl mx-auto"
          >
            sur l'une des plus belles vagues
            <br class="lg:hidden" />du monde !
          </p>
          <p
            class="text-[#0D2651] text-[22px] sm:text-[26px] lg:text-[32px] max-w-2xl mx-auto mb-8 sm:mb-10 font-barlow-condensed font-bold"
          >
            En découvrant si votre produit<br />
            Petit Navire contient un code gagnant
          </p>
          <div
            class="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4"
          >
            <button
              type="button"
              class="inline-flex items-center justify-center hover:opacity-95 transition-opacity focus:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-[50px]"
              @click="scrollToCode"
            >
              <img
                src="@/assets/images/dotations/ou-trouver-mon-code.svg"
                alt="Où trouver mon code ?"
                class="w-auto h-[56px] sm:h-[68px] lg:h-[84px]"
              />
            </button>
            <router-link
              to="/form"
              class="inline-flex items-center justify-center hover:opacity-95 transition-opacity"
            >
              <img
                src="@/assets/images/dotations/CTA-dark.svg"
                alt="Je découvre si j'ai gagné un voyage"
                class="w-auto h-[56px] sm:h-[68px] lg:h-[84px]"
              />
            </router-link>
          </div>
          <button
            type="button"
            class="mt-8 sm:mt-10 inline-block opacity-90 hover:opacity-100 transition-opacity"
            aria-label="Défiler vers la suite"
            @click="scrollToCode"
          >
            <img
              src="@/assets/images/dotations/scrolldown.svg"
              alt=""
              class="w-[28px] h-[66px] mx-auto animate-bounce brightness-0 invert"
            />
          </button>
        </div>

        <!-- Où trouver mon code -->
        <div id="dotation-code" class="scroll-mt-28 text-center">
          <div
            class="inline-flex items-center justify-center rounded-2xl bg-[#FEEFC7] px-5 pt-0.5 pb-2 mb-3 sm:mb-4 max-w-[95vw]"
          >
            <h2
              class="font-barlow-condensed font-bold text-[#0D2651] uppercase text-[44px] sm:text-[52px] lg:text-[64px] leading-tight text-center"
            >
              Où trouver mon code ?
            </h2>
          </div>
          <p
            class="font-barlow-condensed font-bold text-[#0D2651] uppercase text-[24px] sm:text-[32px] lg:text-[40px] mb-8 sm:mb-10"
          >
            pour savoir si vous avez gagné
          </p>

          <div
            class="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-2 lg:gap-0 max-w-[780px] md:max-w-[960px] lg:max-w-[1100px] mx-auto"
          >
            <div class="flex justify-center md:justify-end md:pr-[5px]">
              <img
                src="@/assets/images/forms/form-gauche.png"
                alt="Boîte de thon Petit Navire — où trouver le code"
                class="w-full max-w-[92%] rounded-2xl object-cover"
              />
            </div>
            <div class="flex justify-center md:justify-start md:pl-[5px]">
              <img
                src="@/assets/images/forms/form-droite.png"
                alt="Paquet saumon Petit Navire — où trouver le code"
                class="w-full max-w-[92%] rounded-2xl object-cover"
              />
            </div>
          </div>

          <router-link
            to="/form"
            class="mt-10 sm:mt-12 inline-block max-w-[95vw] hover:opacity-95 transition-opacity mx-auto"
          >
            <img
              src="@/assets/images/dotations/CTA-clair.svg"
              alt="Je découvre si j'ai gagné un voyage"
              class="w-full max-w-[500px] sm:max-w-[580px] lg:max-w-[700px] h-auto mx-auto"
            />
          </router-link>
          <p
            class="mt-4 sm:mt-5 text-[#0D2651] text-lg sm:text-xl lg:text-2xl font-barlow-condensed font-bold"
          >
            *Découvrez la liste des produits éligibles en
            <a
              href="/documents/Fiche%20produit%20site_voyage.pdf"
              target="_blank"
              rel="noopener noreferrer"
              class="underline font-bold"
              >cliquant ici</a
            >
          </p>
        </div>
      </div>
    </section>

    <!-- ========== SECTION 2 : kit collector — même fond que Home section 3 (vague incluse au SVG) ========== -->
    <section
      class="dotation-s2 relative z-[12] w-full max-w-[1440px] mx-auto overflow-visible text-white text-center -mt-[48px] sm:-mt-14 lg:-mt-20 xl:-mt-24 dotation-s2-fond"
    >
      <!-- OU : centré sur la vague entre plage et section 3 -->
      <div
        class="dotation-ou-wrap absolute left-1/2 z-[50] flex w-full max-w-[1440px] justify-center pointer-events-none px-4"
        aria-hidden="true"
      >
        <img
          src="@/assets/images/dotations/ou.svg"
          alt=""
          class="dotation-ou-img h-auto w-[76px] sm:w-[90px] lg:w-[100px]"
        />
      </div>
      <div
        class="relative z-[2] dotation-s2-inner px-4 sm:px-6 pt-20 sm:pt-24 lg:pt-28 pb-16 sm:pb-20 lg:pb-24"
      >
        <img
          src="@/assets/images/dotations/tentez de gagner.svg"
          alt="Tentez de gagner"
          class="mx-auto mb-6 sm:mb-8 w-[min(85vw,280px)] sm:w-[min(75vw,380px)] lg:w-[480px] h-auto drop-shadow-md"
        />
        <div
          class="inline-flex items-center justify-center rounded-2xl bg-[#FEEFC7] px-5 pt-0.5 pb-2 sm:px-5 sm:pt-0.5 sm:pb-2 mb-8 sm:mb-10"
        >
          <h2
            class="font-barlow-condensed font-bold text-[#0D2651] uppercase text-[44px] sm:text-[52px] lg:text-[64px] lg:leading-[76px] leading-tight"
          >
            1 kit dégustation collector
          </h2>
        </div>

        <div
          class="grid sm:grid-cols-2 gap-6 sm:gap-2 lg:gap-0 max-w-[800px] lg:max-w-[1000px] mx-auto items-start text-center mb-10 sm:mb-12"
        >
          <div>
            <img
              src="@/assets/images/dotations/specialSalade.svg"
              alt="Spécial Salades"
              class="w-full max-w-[380px] lg:max-w-[493px] mx-auto"
            />
            <p
              class="text-white text-xl sm:text-[22px] lg:text-[24px] lg:leading-[28px] mt-4 max-w-[430px] mx-auto font-barlow-condensed font-bold text-center"
            >
              Un saladier en porcelaine de Limoges pour servir vos meilleurs
              plats cuisinés avec Petit Navire
            </p>
          </div>
          <div>
            <img
              src="@/assets/images/dotations/specialApero.svg"
              alt="Spécial Apéros"
              class="w-full max-w-[380px] lg:max-w-[493px] mx-auto"
            />
            <p
              class="text-white text-xl sm:text-[22px] lg:text-[24px] lg:leading-[28px] mt-4 max-w-[355px] mx-auto font-barlow-condensed font-bold text-center"
            >
              Un duo de bols en porcelaine de Limoges parfait pour vos plus
              beaux apéros
            </p>
          </div>
        </div>

        <router-link
          to="/formig"
          class="inline-block max-w-[95vw] hover:opacity-95 transition-opacity"
        >
          <img
            src="@/assets/images/dotations/CTA-beige.svg"
            alt="Je tente de gagner un kit collector"
            class="w-full max-w-[460px] sm:max-w-[540px] lg:max-w-[640px] h-auto mx-auto"
          />
        </router-link>
        <p
          class="mt-4 sm:mt-5 text-white text-lg sm:text-xl lg:text-2xl font-barlow-condensed font-bold"
        >
          *Découvrez la liste des produits éligibles en
          <a
            href="/documents/Fiche%20produit%20site_kit.pdf"
            target="_blank"
            rel="noopener noreferrer"
            class="underline font-bold"
            >cliquant ici</a
          >
        </p>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: "DotationView",
  methods: {
    scrollToCode() {
      const el = document.getElementById("dotation-code");
      if (el) {
        const y = el.getBoundingClientRect().top + window.pageYOffset - 100;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    },
  },
};
</script>

<style scoped>
/* Fond page : même famille que la plage pour éviter une barre sous le header */
.dotation-page {
  background-color: #5dade2;
}

.dotation-s1 {
  min-height: min(100vh, 900px);
}

/* Identique à .home3 (HomeView section 3) — pas de couleur de fond, seulement le SVG */
.dotation-s2-fond {
  background-color: transparent;
  background-image: url("@/assets/images/dotations/fond-section2.svg"),
    linear-gradient(to bottom, transparent 80px, #0d2651 80px);
  background-size: 100% auto, 100% 100%;
  background-position: top center, top center;
  background-repeat: no-repeat, no-repeat;
}

@media (min-width: 641px) {
  .dotation-s2-fond {
    background-image: url("@/assets/images/dotations/fond-section2.svg"),
      linear-gradient(to bottom, transparent 100px, #0d2651 100px);
  }
}

@media (min-width: 1024px) {
  .dotation-s2-fond {
    background-image: url("@/assets/images/dotations/fond-section2.svg"),
      linear-gradient(to bottom, transparent 130px, #0d2651 130px);
  }
}

@media (max-width: 640px) {
  .dotation-s2-fond {
    background-color: #0d2651;
    background-size: 300% auto;
    background-position: top center;
  }
}

.dotation-s2-inner {
  background-color: transparent;
}

/* OU en blanc : lisible sur plage (clair) et sur bleu */
/* OU : à cheval sur la limite (remonte un peu hors de la section 2) */
.dotation-ou-wrap {
  top: 14px;
  transform: translate(-50%, -50%);
}

.dotation-ou-img {
  filter: drop-shadow(0 0 1px #0d2651) drop-shadow(0 0 6px #0d2651)
    drop-shadow(0 2px 8px rgba(0, 0, 0, 0.45));
}

/* Bloc beige + titre — aligné Figma / FormView section 2 */
.dotation-code-title-wrap {
  display: inline-flex;
  height: 80px;
  padding: 2px 18px 8px 18px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 16px;
  background: var(--Beige, #feefc7);
}

.dotation-code-title {
  color: var(--Bleu-Petit-Navire, #0d2651);
  text-align: center;
  font-family: "Barlow Condensed", sans-serif;
  font-size: clamp(1.35rem, 4.5vw, 56px);
  font-style: normal;
  font-weight: 700;
  line-height: 68px;
  text-transform: uppercase;
  margin: 0;
}

@media (max-width: 1023px) {
  .dotation-code-title-wrap {
    height: auto;
    min-height: 78px;
    padding: 10px 18px;
  }
  .dotation-code-title {
    line-height: 1.2;
  }
}

@media (min-width: 1024px) {
  .dotation-code-title {
    font-size: 56px;
  }
}
</style>
